export const BASIS_OF_AUTHORITY_SELECT_TEST_ID = 'BASIS_OF_AUTHORITY_SELECT_TEST_ID';
export const BASIS_OF_AUTHORITY_ITEM_TEST_ID = 'BASIS_OF_AUTHORITY_ITEM_TEST_ID';
export const PROXY_NUMBER_TEST_ID = 'PROXY_NUMBER_TEST_ID';
export const PROXY_DATE_TEST_ID = 'PROXY_DATE_TEST_ID';
